<template>
  <v-card color="#FFFFFF" elevation=0 tile :class="classes" class="">
    <slot></slot>
  </v-card>
</template>

<script>
export default {
  props: {
    min: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({}),
  computed: {
    // `large`に応じてクラスを動的に生成する
    classes () {
      const cls = this.min ? 'pa-0' : 'pa-2'
      return cls
    }
  }
}
</script>
